import React from 'react'
import AnalyticsDateFilterSkeleton from './AnalyticsDateFilterSkeleton'

const AnalyticsHeaderSkeleton = ({ primary = false, filter = false }) => {
    return (
        <>
            <div className="w-full rounded-[10px] relative min-h-[120px] flex flex-row items-center justify-between px-10 bg-[#7780c4]/50 animate-pulse">
                {!primary ? (
                    <div className="flex flex-col justify-center">
                        <div className="h-[31px] w-[150px] bg-lightBG rounded mb-2 opacity-50"></div>
                        <div className="h-[14px] w-[130px] bg-lightBG rounded opacity-50"></div>
                    </div>
                ) : (
                    <div className="flex flex-row items-center gap-[28px]">
                        <div className="h-[40px] w-[320px] bg-lightBG rounded opacity-50"></div>
                        <div className="flex items-center gap-2">
                            <div className="h-[40px] w-[40px] bg-lightBG rounded-full opacity-50"></div>
                            <div className="h-[40px] w-[150px] bg-lightBG rounded-full opacity-50"></div>
                            <div className="h-[40px] w-[40px] bg-lightBG rounded-full opacity-50"></div>
                        </div>
                    </div>
                )}
                <div className="h-[100px] w-[100px] bg-[#7780c4] rounded-full opacity-50 mr-[60px]"></div>
            </div>
            {filter && <AnalyticsDateFilterSkeleton />}
        </>
    )
}

export default AnalyticsHeaderSkeleton
